import { defineComponent, onMounted, ref } from 'vue';
import { BUTTON_NEW_SIZE, BUTTON_NEW_TYPE } from '@hems/util/src/constant/button';
export default defineComponent({
    name: 'ButtonNew',
    props: {
        size: {
            type: String,
            default: BUTTON_NEW_SIZE.SMALL,
        },
        type: {
            type: String,
            default: BUTTON_NEW_TYPE.SOLID,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['mounted'],
    setup(_props, { emit }) {
        const buttonRef = ref(null);
        onMounted(() => {
            emit('mounted', buttonRef.value);
        });
        return {
            buttonRef,
        };
    },
});
